import { localStorageUtils } from '../storage/localStorage';

export const runOnce = (key: string, callback: () => void) => {
  if (!localStorageUtils.getBooleanItem(key, false)) {
    localStorageUtils.setItem(key, true);
    callback();
  }
};
